
export const parseLocation = (location) => {
  if (!location) { // go no where
    return
  }

  if (typeof location === "string" || !location.state) {
    return location
  }

  // strip any circlular refs + functions from state as browserHistory will fail on this
  const state = JSON.parse(JSON.stringify(location.state))

  return {
    ...location,
    state
  }
}

export const addContext = (location, context) => {
  let url = typeof context === "string" ? context : context.appPath
  if (url === "/") {
    url = ""
  }
  if (typeof location === "string") {
    return `${url}${location.replace(/^[/]*/, "/")}`
  } else if (location) {
    return {...location, pathname: addContext(location.pathname, url)}
  }
}

export const appOrContext = ({to, app}, context) => {
  if (app) {
    return addContext(to, app)
  }
  return addContext(to, context)
}
